import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { TopBanner } from "./TopBanner";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { StickyCTA } from "./StickyCTA";

const scrollToHash = (hash) => {
  const el = document.getElementById(decodeURIComponent(hash.slice(1)));
  if (el) el.scrollIntoView({ behavior: "auto", block: "start" });
  return !!el;
};

const useRouteScroll = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    const raf = requestAnimationFrame(() => scrollToHash(hash));
    const timer = setTimeout(() => scrollToHash(hash), 350);
    document.fonts?.ready.then(() => scrollToHash(hash));
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(timer);
    };
  }, [pathname, hash]);
};

export const Layout = ({ children, stickyCta = false, chrome = true, footerVariant = "default", top = null }) => {
  useRouteScroll();
  return (
    <div className={`page-glow min-h-screen ${stickyCta ? "pb-[84px] md:pb-0" : ""}`}>
      {chrome && <TopBanner />}
      {chrome && <Header />}
      {top && <div className="sticky top-0 z-40" data-testid="sticky-top">{top}</div>}
      <main>{children}</main>
      <Footer variant={footerVariant} />
      {stickyCta && <StickyCTA />}
    </div>
  );
};
